// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "Commissioni delle OTA",
    sub: "Quanto trattiene ogni canale dalle tue prenotazioni. Così la scheda di ogni prenotazione ti dà una stima di quanto ti arriva.",
  },
  loading: "Caricamento delle commissioni…",
  loadError: {
    title: "Impossibile caricare le commissioni",
    text: "Controlla la connessione e riprova.",
    retry: "Riprova",
  },
  display: {
    title: "Prezzo delle prenotazioni OTA nella scheda",
    totalLabel: "Solo il totale inviato dall'OTA",
    totalDesc: "Come finora: l'importo della prenotazione.",
    netLabel: "Anche quanto ti arriva",
    netDesc: "Oltre al totale, la scheda mostra la commissione, l'IVA sulla commissione e il netto che riceverai.",
  },
  rates: {
    title: "Commissione e addebiti di ogni OTA",
    hint: "Inserisci la % che vedi nell'extranet di ogni OTA (su Booking: «Commissione e addebiti» ÷ «Prezzo totale»). Se il canale comunica la commissione reale di una prenotazione, si usa quella.",
    usual: "abituale: {pct}%",
    airbnbNote: "Airbnb ti paga l'importo già netto: la sua commissione è già detratta. Lascia vuoto (0%) a meno che la tua connessione non riceva il totale.",
    managedNote: "Queste percentuali si usano anche nella liquidazione al tuo proprietario.",
  },
  vat: {
    title: "IVA sulla commissione dell'OTA",
    hint: "Booking applica l'IVA sulla sua commissione agli alloggi in Spagna (21%) e la trattiene dal bonifico. Inserisci 0 se non te la addebitano.",
  },
  errPercent: "Deve essere una percentuale tra 0 e 100.",
  example: {
    title: "Esempio",
    sub: "Una prenotazione {channel} da {total}",
    total: "Prezzo totale",
    commission: "Commissione e addebiti di {channel} ({pct}%)",
    vat: "IVA sulla commissione ({pct}%)",
    net: "Ti arriva",
    foot: "È una stima con queste percentuali: l'OTA può trasferire una cifra un po' diversa (arrotondamenti, promozioni, costi di pagamento). Se il canale comunica la commissione reale, la scheda usa quella.",
  },
  footer: {
    save: "Salva",
    saving: "Salvataggio…",
    saved: "Commissioni salvate",
    unsaved: "Modifiche non salvate",
    fixErrors: "Controlla i campi evidenziati",
    errSave: "Impossibile salvare le modifiche. Riprova.",
    errInvalid: "La commissione di ogni OTA deve essere una percentuale tra 0 e 100.",
  },
};
